AdUnitLazyLoader = window.AdUnitLazyLoader =
  load: ->
    $('.ad-widget iframe').attr 'src', ->
      $(this).attr('data-src')


module.exports = AdUnitLazyLoader
